var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6704 58.7381L27.4852 10.5535C19.9257 2.99396 6.99997 8.34795 6.99997 19.0388L6.99989 98.4185C6.99989 109.109 19.9257 114.463 27.4852 106.904L75.6606 58.7284L75.6704 58.7381ZM32.435 5.6038L80.6201 53.7884L80.6104 63.6781L32.435 111.854C20.4656 123.823 -9.65946e-05 115.346 -9.58547e-05 98.4185L-3.89792e-05 19.0388C-3.95879e-05 2.11162 20.4657 -6.36554 32.435 5.6038Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2804 67.2131L89.9702 106.903C97.5298 114.463 110.455 109.109 110.455 98.4177L117.455 98.4177C117.455 115.345 96.9898 123.822 85.0205 111.853L45.3306 72.1629C37.9106 64.7429 37.9106 52.7128 45.3306 45.2928L85.0205 5.60294C96.9898 -6.36639 117.456 2.11081 117.456 19.038L110.456 19.038C110.456 8.3471 97.5298 2.99313 89.9702 10.5527L50.2803 50.2426C45.594 54.9289 45.5941 62.5268 50.2804 67.2131Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4187 110.456C109.11 110.456 114.464 97.5307 106.904 89.9711L58.7285 41.7957L58.7382 41.786L63.6783 36.8459L111.854 85.0214C123.823 96.9907 115.346 117.456 98.4187 117.456V110.456Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7764 80.6042L106.901 27.4856C114.461 19.926 109.107 7.00009 98.416 7.00009L98.416 8.2259e-05C115.343 8.37388e-05 123.82 20.466 111.851 32.4353L58.7217 85.5574L53.7764 80.6042Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 114.998,
    y1: 58.7287,
    x2: -0.0000949799,
    y2: 58.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.7656,
    y1: 58.7279,
    x2: 93.8498,
    y2: 4.64372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 54.2786,
    y1: 36.8459,
    x2: 108.375,
    y2: 88.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 55.5439,
    y1: 81.9423,
    x2: 112.979,
    y2: 24.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9200"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ca5d43df8fb0f49a51bd44b0b3dd1da.svg";
export { ForwardRef as ReactComponent };